export default "__VITE_ASSET__Q5Hq9asR__"